import { render, staticRenderFns } from "./copy-scadenza.vue?vue&type=template&id=49c57357&"
import script from "./copy-scadenza.vue?vue&type=script&lang=js&"
export * from "./copy-scadenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports